import React from 'react';
import './Register.css';
function Modal(props){
    return(
        <div className='modal-dialog-wrapper'>
                    <div className="modal-dialog modal-confirm">
		                <div className="modal-content">
		                	<div className="modal-header">
		                		<div className="icon-box">
                                &#10003;
		                		</div>				
		                		<h4 className="modal-title w-100">Registered!</h4>	
		                	</div>
		                	<div className="modal-body">
		                		<p className="text-center">Your registration has been succesfull, click next to proceed.</p>
		                	</div>
		                	<div className="modal-footer">
		                		<button onClick={()=>props.setStep("2")} className="btn btn-success btn-block" data-dismiss="modal">Next</button>
		                	</div>
		                </div>
	                </div>
                </div>
    );
}
export default Modal;